import React, { useState, useEffect, useContext  } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
  Container,
  Typography,
  Button,
  Alert,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Stack,
    Card,
    CardContent,
  MenuItem,
  TextField,
  CircularProgress
} from '@mui/material';

import documentoApi from '../../api/documentoApi';
import contribuenteApi from '../../api/contribuenteApi';
import logprocessoApi from '../../api/logprocessoApi';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import { AuthContext } from '../../auth/AuthContext';
import { formatDate } from '../../utils/dateFormatter';

const extractErrorMessage = (error) => {
  if (!error) return 'Errore sconosciuto';
  if (error.response?.data) return JSON.stringify(error.response?.data);
  if (!error.response) {
    return "L'elaborazione richiede più tempo del previsto. Riprova.";
  }
  return error.message || JSON.stringify(error);
};

export default function DocumentoUploadPageDesktop() {
  const { id, contribuenteId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
    const { user } = useContext(AuthContext);

  const documentoFascicoloId = location.state?.documentoFascicoloId;
  const fromFascicolo = !!documentoFascicoloId;

  const isNew = !id;
  const hasContribuenteFromRoute = !!contribuenteId;

  const [file, setFile] = useState(null);
  const [previewData, setPreviewData] = useState(null);
  const [err, setErr] = useState(null);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [saving, setSaving] = useState(false);

  const [contribuenti, setContribuenti] = useState([]);
  const [selectedContribuente, setSelectedContribuente] = useState('');

  /* =========================
     INIT CONTRIBUENTE
     ========================= */
  useEffect(() => {
    if (hasContribuenteFromRoute) {
      setSelectedContribuente(Number(contribuenteId));
    } else if (id) {
      documentoApi
        .get(id)
        .then(r => setSelectedContribuente(Number(r.data.contribuenteId)))
        .catch(e => setErr(extractErrorMessage(e)));
    }
  }, [contribuenteId, id, hasContribuenteFromRoute]);

  useEffect(() => {
    if (isNew && !hasContribuenteFromRoute) {
      contribuenteApi
        .list({ page: 0, size: 100 })
        .then(r => setContribuenti(r.data.content || []))
        .catch(e => setErr(extractErrorMessage(e)));
    }
  }, [isNew, hasContribuenteFromRoute]);

  /* =========================
     FILE
     ========================= */
  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      setFile(e.target.files[0]);
      setPreviewData(null);
      setErr(null);
    }
  };

  /* =========================
     PREVIEW
     ========================= */
  const generatePreview = async () => {
    if (!fromFascicolo && !file) return;
    if (!selectedContribuente) {
      setErr('Selezionare un contribuente');
      return;
    }

    setLoadingPreview(true);
    setErr(null);

    try {
      const formData = new FormData();

      if (file) {
        formData.append('file', file);
      }

      formData.append('contribuenteId', selectedContribuente);

      if (documentoFascicoloId) {
        formData.append('documentoFascicoloId', documentoFascicoloId);
      }

      const response = isNew
        ? await documentoApi.newpreviewupload(formData)
        : await documentoApi.previewupload(id, formData);

      const processoId = response.data.id;

      let completed = false;
      while (!completed) {
        await new Promise(r => setTimeout(r, 1000));
        const statusResp = await logprocessoApi.trova(processoId);
        const p = statusResp.data;

        if (p.stato === 'COMPLETED') {
          completed = true;
          if (p.esito === 'OK') {
            setPreviewData(p.testo);
          } else {
            setErr(p.anomalie || 'Errore nel parsing');
          }
        }
      }
    } catch (e) {
      setErr(extractErrorMessage(e));
    } finally {
      setLoadingPreview(false);
    }
  };

  /* =========================
     SAVE
     ========================= */
  const confirmUpload = async () => {
    if (isNew && !selectedContribuente) {
      setErr('Contribuente mancante');
      return;
    }

    setSaving(true);
    setErr(null);

    try {
      previewData.contribuenteId = selectedContribuente;

      const response = isNew
        ? await documentoApi.create(previewData, documentoFascicoloId)
        : await documentoApi.update(id, previewData, documentoFascicoloId);
        console.log("user.role",user.role);

        if(user.role==="CONTRIBUENTE" && (!contribuenteId || contribuenteId=='undefined')){
          contribuenteId=user.contribuenteId;
        }
        console.log("contribuenteId",contribuenteId);
      if(user.role==="CONTRIBUENTE" && contribuenteId)
        navigate(`/documenti/bycontribuente/${contribuenteId}`);
      else
        navigate(`/contribuenti/${selectedContribuente}`);
    } catch (e) {
      setErr(extractErrorMessage(e));
    } finally {
      setSaving(false);
    }
  };

  /* =========================
     RENDER
     ========================= */
  return (
    <Container>
             {loadingPreview && (
               <Box
                 sx={{
                   position: 'fixed',
                   inset: 0,
                   bgcolor: 'rgba(255,255,255,0.7)',
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center',
                   zIndex: 1300,
                 }}
               >
                 <CircularProgress size={48}/>
               </Box>
             )}
      <BackButtonDesktop />

      <Typography variant="h5" sx={{ mb: 2 }}>
        {fromFascicolo
          ? 'Crea Scadenze da Documento Fascicolo'
          : isNew
          ? 'Crea Documento da PDF'
          : 'Aggiungi PDF al Documento'}
      </Typography>
<Alert severity="warning" sx={{ mb: 2 }}>Tipologie di documento caricabili in questa pagina: F24 (UNICO o RATEIZZAZIONE AVVISO BONARIO), RATEIZZAZIONE ADE, ROTTAMAZIONE, MULTA, ACCERTAMENTO TARI, SOLLECITO TARI, INTIMAZIONE DI PAGAMENTO SINGOLA RATA. I dati estratti dai documenti PDF sono solo indicativi e servono a fornire
                                        informazioni all utente soprattutto riguardo alle date delle scadenze fiscali da pagare, alle quali
                                        viene prestata la massima attenzione. Gli importi e i codici dei moduli di pagamento
                                       saranno presenti ed accurati nella misura in cui i file PDF caricati sono
                                       leggibile dal software OCR che li interpreta (è indispensabile una risoluzione dei PDFF di almeno 300dpi, se sono scansionati). Si invita l utente a consultare sempre il documento originale
                                       che viene caricato nel fascicolo ed allegato alle scadenze</Alert>
      {err && <Alert severity="error" sx={{ mb: 2 }}>{err}</Alert>}

      {/* Upload PDF SOLO se NON si viene dal fascicolo */}
      {!fromFascicolo && (
        <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
          <input
            accept="application/pdf"
            style={{ display: 'none' }}
            id="file-upload"
            type="file"
            onChange={handleFileChange}
          />
          <label htmlFor="file-upload">
            <Button variant="outlined" component="span">
              {file ? 'Cambia PDF' : 'Sfoglia PDF'}
            </Button>
          </label>
          {file && <Typography>{file.name}</Typography>}
        </Stack>
      )}

      <Button
        variant="contained"
        onClick={generatePreview}
        disabled={loadingPreview || (!fromFascicolo && !file)}
      >
        {loadingPreview ? 'Generazione...' : 'Anteprima dati'}
      </Button>

      {previewData && (
        <Box sx={{ mt: 4 }}>
                  <Card>
                    <CardContent>
                      <Typography variant="h6">Preview Documento</Typography>
                      {previewData.descrizione && <Typography>Descrizione: {previewData.descrizione}</Typography>}
                      {previewData.numeroDocumento && <Typography>Numero Documento: {previewData.numeroDocumento}</Typography>}
                      {previewData.dataDocumento && <Typography>Data Documento: {formatDate(previewData.dataDocumento)} </Typography>}
                      {previewData.enteRiscossione && <Typography>Ente: {previewData.enteRiscossione}</Typography>}
                      {previewData.cfContribuente && <Typography>CF: {previewData.cfContribuente}</Typography>}
                      {previewData.nomeContribuente && <Typography>Destinatario: {previewData.nomeContribuente}</Typography>}
                      {previewData.indirizzoContribuente && <Typography>Indirizzo: {previewData.indirizzoContribuente}</Typography>}
                    </CardContent>
                  </Card>
          <Typography variant="h6">Scadenze</Typography>

          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Rata</TableCell>
                <TableCell>Data</TableCell>
                <TableCell>Importo</TableCell>
                <TableCell>Codice</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {previewData.scadenze?.map((s, i) => (
                <TableRow key={i}>
                  <TableCell>{s.numerorata}</TableCell>
                  <TableCell>{formatDate(s.dataScadenza)}</TableCell>
                  <TableCell>{s.importo}</TableCell>
                  <TableCell>{s.codiceModuloPagamento}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <Button
            sx={{ mt: 2 }}
            variant="contained"
            color="success"
            onClick={confirmUpload}
            disabled={saving}
          >
            {saving ? 'Salvataggio...' : 'Conferma e Salva'}
          </Button>
        </Box>
      )}
    </Container>
  );
}
